export const STEPS = {
  AGREEMENT: 'agreement',
  WITHDRAWAL_FORM: 'withdrawal_form',
  CONFIRMATION: 'confirmation'
}

export const BOOKER_EMAIL = 'tatyanak@super-ego.info'

export const MIN_WITHDRAWAL_LIMIT = 2 * 1000
export const MAX_WITHDRAWAL_LIMIT = 100 * 1000

export const DEFAULT_CURRENCY_ID = 1

export const WITHDRAWAL_TYPES = {
  TO_BANK_CARD: 'WithdrawalByCard',
  TO_CHECKING_ACCOUNT: 'WithdrawalByBankAccount'
}

export const DEFAULT_WITHDRAWAL_TYPE = WITHDRAWAL_TYPES.TO_BANK_CARD

export const WIDGET_CONTAINER_ID = 'payment-widget-container'
